import Current from "@hydrologiq/shared/figures/generic/Current"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

interface HeadlineFigureData {
  value: number | null
  unit: string | null
  label: string
  available: boolean
  lastUpdated?: string | null
  metadata?: any
}

interface CurrentLevelFigureProps {
  data: HeadlineFigureData
  loading?: boolean
  error?: string
}

function CurrentLevelFigure({ data, loading, error }: CurrentLevelFigureProps) {
  // Extract pressure from metadata for hydrogen assets
  const secondary =
    (typeof data?.metadata?.pressure === "number" ? data?.metadata?.pressure : data?.metadata?.pressure?.value) ??
    undefined

  // In overview mode, show a placeholder when no data is available
  const isPlaceholder = !data.available || error !== undefined || !data.label

  return (
    <Current
      heading={data.label || "Current Level"}
      current={data.value ?? undefined}
      secondary={secondary}
      loading={loading}
      isPlaceholder={isPlaceholder}
      compact={isCompactFigure("summary")}
    />
  )
}

export default CurrentLevelFigure
